export default "__VITE_ASSET__ad319533__"